import {
   AdmirationIcon,
   CircleAtenyaLogo,
   DisgustIcon,
   JoyIcon,
   LinkArrowIcon,
   LoveIcon,
   NervousnessIcon,
   SadnessIcon
} from 'assets'
import { CustomModal } from 'components'
import React, { useState } from 'react'
import { useEffect } from 'react'
import ReactApexChart from 'react-apexcharts'
import ProgressBar from 'react-bootstrap/ProgressBar'
import { useSelector } from 'react-redux'
// import VideoSummaryModal from './VideoSummaryModal'
// import VideoContentModal from './VideoContentModal'
import { getEmotionFColor, getEmotionIcon, getEmotionSColor } from 'utils/getEmotionIcon'

function InAtenyaAi() {
   // const videoRedux = useSelector((state) => state.videoRedux)
   // const { videoDetails: videoDetailsData } = videoRedux

   const instagramDashboardData = useSelector((state) => state.instagramDashboard)
   const { loading, postDetails } = instagramDashboardData

   const [isPositive, setIsPositive] = useState(true)

   const [positiveArray, setPositiveArray] = useState([])
   const [negativeArray, setNegativeArray] = useState([])
   const [openShowMoreModal, setOpenShowMoreModal] = useState(false)
   const [videoSummaryModal, setVideoSummaryModal] = useState(false)
   const [videoContentModal, setVideoContentModal] = useState(false)

   const onCloseContentModal = () => {
      setVideoContentModal(false)
   }

   const onCloseSummaryModal = () => {
      setVideoSummaryModal(false)
   }

   useEffect(() => {
      if (postDetails) {
         if (
            postDetails?.top_positive_comments &&
            postDetails?.top_positive_comments?.length > 0
         ) {
            const firstThreeObjects = postDetails?.top_positive_comments.slice(0, 3)
            setPositiveArray(firstThreeObjects)
         }
         if (
            postDetails?.top_negative_comments &&
            postDetails?.top_negative_comments?.length > 0
         ) {
            const firstThreeObjects = postDetails?.top_negative_comments.slice(0, 3)
            setNegativeArray(firstThreeObjects)
         }
      } else {
         setPositiveArray([])
         setNegativeArray([])
      }

      return () => {}
   }, [postDetails])

   const onCloseModal = () => {
      setOpenShowMoreModal(!openShowMoreModal)
   }

   return (
      <div className="hello-atenya-wrap">
         <div className="card">
            <div className="row">
               <div className="col-12 col-lg-5">
                  <div className="atenya-ai-section">
                     <div className="atenya-ai-title-section">
                        <div className=" atenya-ai-title-wrap">
                           <h2 className="at-text-dark">Hello from Atenya AI!</h2>
                           <p className="at-text-light">
                              Here's a quick breakdown of the feedback:
                           </p>
                        </div>
                        {/* <div className="atenya-logo">
                        <img src={CircleAtenyaLogo} alt="atenya-logo" />
                     </div> */}
                     </div>
                     <div className="atenya-desc mt-2">
                        I'm here to help you monitor comments, engage with followers, and analyze
                        sentiment. To gain deeper insights into what’s driving these emotions, it
                        would be beneficial to explore specific comments and user interactions.
                        Let’s dive in!
                     </div>
                     <div className="atenya-counter mt-3">
                        <div className="row">
                           <div className="col-6 col-lg-6">
                              <div className="atenya-counter-wrap">
                                 <h3 className="at-text-dark">
                                    {postDetails?.compliments || 0}
                                 </h3>
                                 {/* <small className="text-success">+2.4%</small> */}
                              </div>
                              <span className="at-text-light atenya-counter-sub-title">
                                 {' '}
                                 Compliments
                              </span>
                           </div>
                           <div className="col-6 col-lg-6">
                              <div className="atenya-counter-wrap">
                                 <h3 className="at-text-dark">
                                    {postDetails?.criticism || 0}
                                 </h3>
                                 {/* <small className="text-success">+2.4%</small> */}
                              </div>
                              <span className="at-text-light atenya-counter-sub-title">
                                 {' '}
                                 Criticisms
                              </span>
                           </div>
                        </div>
                     </div>
                     <div className="atenya-ai-btn-group mt-3">
                        {postDetails?.is_content_summary && (
                           <>
                              <div
                                 className="atenya-ai-btn"
                                 onClick={() => {
                                    setVideoSummaryModal(true)
                                 }}>
                                 <span>Video Summary</span>
                                 <div className="at-icon">
                                    <LinkArrowIcon />
                                 </div>
                              </div>

                              <div
                                 className="atenya-ai-btn"
                                 onClick={() => {
                                    setVideoContentModal(true)
                                 }}>
                                 <span>Content Analysis</span>
                                 <div className="at-icon">
                                    <LinkArrowIcon />
                                 </div>
                              </div>
                           </>
                        )}
                     </div>
                  </div>
               </div>
               <div className="col-12 col-lg-7">
                  <div className="positive-emotion">
                     <div className="atenya-positive-title">
                        <div>
                           <h3 className="at-text-dark">Top 3 Emotions</h3>
                           {/* <span className="at-text-light">Updated 2 min ago</span> */}
                        </div>
                        <div>
                           <div className="d-flex gap-3">
                              <div className="hello-at-btn-wrap manu-list-section">
                                 <div
                                    className={`manu-name-section ${isPositive ? 'active' : ''}`}
                                    onClick={() => {
                                       setIsPositive(true)
                                    }}>
                                    Positive
                                 </div>
                                 <div
                                    className={`manu-name-section ${!isPositive ? 'active' : ''}`}
                                    onClick={() => {
                                       setIsPositive(false)
                                    }}>
                                    Negative
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                     <EmotionsChart
                        positiveArray={positiveArray}
                        isPositive={isPositive}
                        negativeArray={negativeArray}
                     />
                     <div className="emotion-list-wrap">
                        <div className="row">
                           {isPositive
                              ? positiveArray?.length > 0 &&
                                positiveArray?.map((item, i) => {
                                   return (
                                      <div className="col-5 col-sm-4 col-lg-4" key={i}>
                                         <div className="emotion-counter-wrap">
                                            <h3 className="at-text-dark">{item?.count}</h3>
                                            {/* <small className="text-success">+2.4%</small> */}
                                         </div>
                                         <div className="at-text-light atenya-counter-sub-title">
                                            {getEmotionIcon(item?.text, 'positive')}
                                            <span className="ms-1 d-inline-block text-capitalize">
                                               {' '}
                                               {item?.text}{' '}
                                            </span>
                                         </div>
                                      </div>
                                   )
                                })
                              : negativeArray?.length > 0 &&
                                negativeArray?.map((item, i) => {
                                   return (
                                      <div className="col-5 col-sm-4 col-lg-4" key={i}>
                                         <div className="emotion-counter-wrap">
                                            <h3 className="at-text-dark">{item?.count}</h3>
                                            {/* <small className="text-success">+2.4%</small> */}
                                         </div>
                                         <div className="at-text-light atenya-counter-sub-title">
                                            {getEmotionIcon(item?.text, 'negative')}
                                            <span className="ms-1 d-inline-block text-capitalize">
                                               {' '}
                                               {item?.text}{' '}
                                            </span>
                                         </div>
                                      </div>
                                   )
                                })}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            {openShowMoreModal && (
               <CustomModal
                  show={openShowMoreModal}
                  title={'Video Analyze'}
                  closeModal={onCloseModal}
                  centered
                  scrollable>
                  <div>{postDetails?.video_analyze}</div>
               </CustomModal>
            )}
            {/* {videoSummaryModal && (
               <VideoSummaryModal
                  videoSummaryModal={videoSummaryModal}
                  onClose={onCloseSummaryModal}
               />
            )}
            {videoContentModal && (
               <VideoContentModal
                  videoContentModal={videoContentModal}
                  onClose={onCloseContentModal}
               />
            )} */}
         </div>
      </div>
   )
}

export default InAtenyaAi

const EmotionsChart = ({ positiveArray, isPositive, negativeArray }) => {
   const [series, setSeries] = useState([])
   const [options, setOptions] = useState({
      chart: {
         height: 350,
         type: 'bar',
         zoom: {
            enabled: false
         },
         toolbar: { show: false },
         brush: { enabled: false }
      },
      plotOptions: {
         bar: {
            borderRadius: 10,
            columnWidth: 50,
            distributed: true
         }
      },
      xaxis: {
         labels: {
            show: false
         }
      },
      fill: {
         type: 'gradient'
      },
      yaxis: {
         axisBorder: {
            show: false
         },
         axisTicks: {
            show: false
         },
         labels: {
            show: false
         }
      },
      legend: {
         show: false
      },
      tooltip: { enabled: false }
   })

   useEffect(() => {
      if (isPositive && positiveArray && positiveArray?.length > 1) {
         let data = []
         let fcolor = []
         let sColor = []
         positiveArray?.map((item) => fcolor.push(getEmotionFColor(item?.text || '', 'positive')))
         positiveArray?.map((item) => sColor.push(getEmotionSColor(item?.text || '', 'positive')))
         setOptions({
            ...options,
            colors: fcolor,
            fill: {
               type: 'gradient',
               gradient: {
                  shadeIntensity: 1,
                  type: 'diagonal1',
                  gradientToColors: sColor,
                  inverseColors: false,
                  opacityFrom: 1,
                  opacityTo: 1,
                  stops: [0, 100]
               }
            }
         })
         positiveArray?.map((item) => data.push(item?.count))
         const aa = {
            name: 'positive',
            data: data
         }
         setSeries([aa])
      } else if (negativeArray && negativeArray.length > 1) {
         let data = []

         negativeArray?.map((item) => data.push(item?.count))
         const aa = {
            name: 'negative',
            data: data
         }
         let fcolor = []
         let sColor = []
         negativeArray?.map((item) => fcolor.push(getEmotionFColor(item?.text || '', 'negative')))
         negativeArray?.map((item) => sColor.push(getEmotionSColor(item?.text || '', 'negative')))
         setOptions({
            ...options,
            colors: fcolor,
            fill: {
               type: 'gradient',
               gradient: {
                  shadeIntensity: 1,
                  type: 'diagonal1',
                  gradientToColors: sColor,
                  inverseColors: false,
                  opacityFrom: 1,
                  opacityTo: 1,
                  stops: [0, 100]
               }
            }
         })
         setSeries([aa])
      } else {
         setSeries([])
      }

      return () => {}
   }, [positiveArray, isPositive, negativeArray])

   return (
      <div>
         <div id="chart">
            {series && options && (
               <ReactApexChart options={options} series={series} type="bar" height={350} />
            )}
         </div>
         <div id="html-dist"></div>
      </div>
   )
}
